export default __webpack_public_path__ + "static/media/stackmap.e83ea004.png";